import React, { useEffect, useState } from 'react';
import { Landmark } from 'lucide-react';
import { toast } from 'sonner';
import { Switch } from '@/components/ui/switch';
import { errMsg } from '@/services/staffAttendanceApi';
import { ewbApi } from '@/services/ewayBillApi';
import { fmtDT } from '@/components/ewayBill/shared';

/** Admin switch: send e-way bills to Tally as vouchers (on), or WMS makes the portal JSON itself (off). */
export const TallyPushSwitch = ({ canEdit, onChanged }) => {
  const [r, setR] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { ewbApi.tallyPush().then(setR).catch(() => setR(null)); }, []);
  if (!r) return null;
  const flip = (on) => {
    setBusy(true);
    ewbApi.setTallyPush(on).then((x) => { setR(x); toast.success(on ? 'New e-way bills go to Tally' : 'New e-way bills wait for the WMS portal JSON'); onChanged(); })
      .catch((e) => toast.error(errMsg(e, 'Could not change it'))).finally(() => setBusy(false));
  };
  return (
    <div className="flex flex-wrap items-center gap-3 rounded-xl border border-indigo-100 bg-white px-4 py-3" data-testid="ewb-tally-push">
      <Landmark className={`w-5 h-5 ${r.enabled ? 'text-teal-700' : 'text-indigo-600'}`} />
      <div className="text-sm">
        <div className="font-semibold" data-testid="ewb-tally-push-state">{r.enabled ? 'Send e-way bills to Tally: ON' : 'Send e-way bills to Tally: OFF — WMS makes the portal JSON'}</div>
        <div className="text-xs text-gray-600">
          {r.enabled ? 'The Tally link creates each voucher; the EWB No comes back from Tally or from the portal results file.'
            : 'Tick waiting bills → Download portal JSON → upload on the GST portal (Bulk Generation) → import the portal results file here.'}
          {r.updated_by_name && ` · changed by ${r.updated_by_name} ${fmtDT(r.updated_at)}`}
        </div>
      </div>
      {canEdit && <Switch checked={r.enabled} disabled={busy} onCheckedChange={flip} className="ml-auto" data-testid="ewb-tally-push-switch" />}
    </div>
  );
};

export default TallyPushSwitch;
